module.exports = __webpack_public_path__ + "img/Slide50.1b2e7942.png";